import { render } from "./AdminSidebarView.vue?vue&type=template&id=0f43c901"
import script from "./AdminSidebarView.vue?vue&type=script&lang=js"
export * from "./AdminSidebarView.vue?vue&type=script&lang=js"

import "./AdminSidebarView.vue?vue&type=style&index=0&id=0f43c901&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__